import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { iconAttributes } from '@/utils/icons';


export default /*@__PURE__*/_defineComponent({
  __name: 'ArrowBack',
  setup(__props) {

const attrs = iconAttributes({ width: 15, height: 16 });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _normalizeProps(_guardReactiveProps(_unref(attrs))), _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.873 7.25L15 7.25L15 8.75L2.873 8.75L8.56925 14.4462L7.5 15.5L6.55671e-07 8L7.5 0.499999L8.56925 1.55375L2.873 7.25Z",
      fill: "currentColor"
    }, null, -1)
  ]), 16))
}
}

})